import useTranslation from 'next-translate/useTranslation';

const PhoneNotice = () => {
  const { t } = useTranslation();

  // this piece of code is duplicated here:
  // src/components/pages/terms/index.tsx
  // due to unbale translation with renderToString()
  return (
    <span className="block mt-1 text-xs ">
      {t('common:call-cost')}
      <br />
      {t('common:communication-cost')}
    </span>
  );
};

export default PhoneNotice;
